<script setup>
import {defineProps, defineEmits} from 'vue';
import {useRouter} from "vue-router";
import {useBaseStore} from '@/stores/BaseStore';
import {getReturnPath} from "@/Helper";

const router = useRouter();
const store = useBaseStore();

// The component has props: "open", "title", "content", "showDashboardButton"
const props = defineProps({
    open: Boolean,
    title: String,
    content: String,
    showDashboardButton: {
        type: Boolean,
        default: true
    },
    showHereButton: {
        type: Boolean,
        default: true
    }
});

// The component can emit one event, "close"
const emit = defineEmits(['close']);

const cancel = () => {
    emit('close');
};

const goToDashboard = () => {
    const returnPath = getReturnPath();

    if (returnPath) {
        window.location.href = returnPath;
    } else {
        router.push({name: 'dashboard'});
    }
    emit('close'); // Close the modal after navigation
};
</script>


<template>
    <div v-if="props.open"
         class="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-50 z-50">
        <div class="bg-white rounded-lg p-2 sm:p-4 lg:w-[600px] w-4/5">
            <div class="flex flex-col items-center px-4 py-6">
                <!-- Celebration SVG icon -->
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                     class="h-8 sm:h-12 lg:h-16 w-8 sm:w-12 lg:w-16 text-green-500 mb-4">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
                <h1 class="text-xl sm:text-2xl lg:text-2xl font-semibold mb-2">
                    {{ props.title || $tt('success_modal__title') + ', ' + store.currentUser.first_name + '!' }}</h1>
                <p class="text-center mb-4 sm:mb-6">{{ props.content || $tt('success_modal__message_completed') }}</p>
                <div class="flex mt-4 w-full">
                    <button v-if="showDashboardButton" @click="goToDashboard"
                            class="sm:px-4 lg:px-4 py-1 sm:py-2 lg:py-2 rounded bg-blue-500 text-white flex-1 ltr:mr-2 rtl:ml-2">
                        {{ $tt('success_modal__go_to_dashboard_button') }}
                    </button>
                    <button @click="cancel" v-if="showHereButton"
                            class="sm:px-4 lg:px-4 py-1 sm:py-2 lg:py-2 rounded bg-white border border-gray-400 text-black flex-1 ltr:ml-2 rtl:mr-2">
                        {{ $tt('success_modal__stay_here_button') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
